import { extractUrlFromLinkJsonLd } from '../url';
export var extractLink = function extractLink(jsonLd) {
  var url = jsonLd.url;
  if (url) {
    if (typeof url === 'string') {
      return url;
    } else {
      return extractUrlFromLinkJsonLd(url);
    }
  }
};